<template>
  <Popover ref="editValuePopover" :showHeader="true" :headerTitle="title">
    <div class="p-2">
      <FormInputText
        :type="type"
        ref="valueTextEntry"
        v-model="value"
        @enter="applyValueEdit"
        :addonSlot="addonSlot">
        <template v-slot:addon>
          <slot name="addon" />
        </template> 
      </FormInputText>

      <div class="row mt-2">
        <div class="col-6 pr-1" v-if="removeButtonEnabled">
          <button class="btn btn-sm btn-default" @click.prevent="removeValueEdit">
            <i class="far fa-trash-alt mr-2"></i>{{removeButtonText}}
          </button>
        </div>
        <div class="col-6 pl-1">
          <button class="btn btn-sm btn-default" @click.prevent="applyValueEdit"><i class="far fa-check status-approved mr-2"></i> {{applyButtonText}}</button>
        </div>
      </div>
    </div>
  </Popover>
</template>


<script>
import Popover from '@/components/popover'

export default {
  name: 'EditValuePopover',
  components: {
    Popover
  },
  props: {
    title: String,
    type: String,
    addonSlot: {
      type: Boolean,
      default: false
    },
    removeButtonEnabled: Boolean,
    removeButtonText: {
      type: String,
      default: 'Remove'
    },
    applyButtonText: {
      type: String,
      default: 'Apply'
    }
  },
  data() {
    return {
      value: ''
    }
  },
  methods: {
    displayFromElement(el, value) {
      this.value = value

      this.$refs.editValuePopover.displayFromElement(el)
      this.$nextTick(() => {
        this.$refs.valueTextEntry.select()
      })
    },
    applyValueEdit() {
      this.$refs.editValuePopover.hidePopover()
      this.$emit('apply', this.value);
    },
    removeValueEdit() {
      this.$refs.editValuePopover.hidePopover()
      this.$emit('remove');
    },
    hidePopover() {
      this.$refs.editValuePopover.hidePopover()
    }
  }
}
</script>